// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput-module__searchInput--uUXhF","animatedBackground":"SearchInput-module__animatedBackground--4ZwLq"};